import {Select, SelectProps} from 'antd'
import React from 'react'
import {useIntl} from 'react-intl'
import {instance as plantsService} from '../../../services/PlantsService'
import {ArgumentOf} from '../../../services/util'
import {instance as elementTypeService} from '../../../services/ElementTypeService'
import {useRevalidator} from 'react-router-dom'
import {markPlantForRevalidation} from '../../../routes/plantRevalidator'
import {markProjectForRevalidation} from '../../../routes/projectRevalidator'

export type PlantTemplateSelectorProps = {
  userPlantTemplateId: string
  plantId: number
  className?: string
}

type LabelRender = SelectProps['labelRender']

export function PlantTemplateSelector({
  userPlantTemplateId,
  plantId,
  className,
}: PlantTemplateSelectorProps) {
  const intl = useIntl()
  const revalidator = useRevalidator()

  const plantTemplates = elementTypeService.getElementTypeTemplates('plant')

  const plantTemplatesOptions = Object.keys(plantTemplates).map((templateId) => ({
    value: templateId,
    label: templateId,
  }))

  const labelRender = (props: {value?: string | number}) => {
    if (!props.value) {
      return null
    }
    const templateId = String(props.value)

    const template = plantTemplates[templateId]

    return (
      <span style={{display: 'flex', alignItems: 'center'}}>
        <img
          style={{marginRight: 8}}
          key={templateId as any}
          src={template.src}
          width={25}
          height={25}
        ></img>
        {intl.formatMessage({id: templateId as string})}
      </span>
    )
  }

  return (
    <Select
      className={className}
      size="large"
      placeholder={intl.formatMessage({id: 'template'})}
      defaultValue={userPlantTemplateId}
      onChange={async (template) => {
        await plantsService.editPlantTemplateByPlantId(plantId, template)
        markProjectForRevalidation()
        revalidator.revalidate()
      }}
      options={plantTemplatesOptions}
      labelRender={labelRender}
      optionRender={labelRender}
    />
  )
}
